import { motion } from "framer-motion";
import { STEPS } from "../../content";
import { Reveal, Eyebrow } from "./Reveal";

export const HowItWorks = () => (
  <section id="how" data-testid="how-section" className="py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-2xl">
        <Eyebrow>How it works</Eyebrow>
        <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[0.95]">
          Four steps from <span className="font-hand text-[var(--coral)] font-normal">"ooh"</span> to front-lawn joy.
        </h2>
      </Reveal>
      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.08}>
            <motion.div
              whileHover={{ y: -8, rotate: i % 2 ? 1.5 : -1.5 }}
              transition={{ type: "spring", stiffness: 260, damping: 18 }}
              data-testid={`step-${s.n}`}
              className="sticker rounded-[28px] bg-white p-7 h-full"
            >
              <span
                className="sticker-sm inline-grid place-items-center w-14 h-14 rounded-full font-display font-bold text-xl"
                style={{ background: s.color }}
              >
                {s.n}
              </span>
              <h3 className="font-display font-semibold text-2xl mt-6">{s.title}</h3>
              <p className="mt-2 text-[var(--ink-soft)] leading-relaxed">{s.text}</p>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
